import DesignSelect from 'components/select/DesignSelect';
import { CapacityPlanRunSummary } from 'core/graphql/CapacityPlanning/models';
import { format } from 'date-fns';

export interface RunSelectorProps {
  runs: CapacityPlanRunSummary[];
  /** Guid of the selected Run, or null when none is selected. */
  selectedRunId: string | null;
  isLoading: boolean;
  onRunChange: (runId: string | null) => void;
  disabled?: boolean;
  /** Width of the select, e.g. `w-[480px]`. */
  className?: string;
}

/** "Created" reads better in a list than the raw `CREATED` enum value. */
const statusLabel = (status: string) =>
  `${status.charAt(0)}${status.slice(1).toLowerCase()}`;

/** The supervisor's own Label names the Run; the file name is the fallback. */
const runLabel = (run: CapacityPlanRunSummary) =>
  `${run.label || run.fileName} · ${format(
    new Date(run.createdAt),
    'dd MMM HH:mm',
  )} · ${statusLabel(run.status)}`;

const RunSelector = ({
  runs,
  selectedRunId,
  isLoading,
  onRunChange,
  disabled,
  className,
}: RunSelectorProps) => {
  const options = runs.map((run) => ({
    value: run.id,
    label: runLabel(run),
  }));
  const selected = options.find((option) => option.value === selectedRunId);

  return (
    <div className="flex flex-col">
      <label
        className="text-sm text-light-black dark:text-sublte-white"
        htmlFor="capacityPlanRunSelect"
      >
        Run
      </label>
      <DesignSelect
        inputId="capacityPlanRunSelect"
        name="capacityPlanRun"
        className={className}
        isLoading={isLoading}
        isDisabled={disabled}
        isClearable
        options={options}
        value={selected ?? null}
        placeholder={
          runs.length === 0
            ? 'No runs yet'
            : 'Select a run, or create one with New run'
        }
        isMulti={false}
        closeMenuOnSelect
        onChange={(option: { value: string } | null) =>
          onRunChange(option ? option.value : null)
        }
      />
    </div>
  );
};

RunSelector.defaultProps = {
  disabled: false,
  className: '',
};

export default RunSelector;
